import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

const TwoImageRow = ({ doc }) => {
  const { heading, description, dark_theme, internal_link_id } = doc?.primary || {};
  return (
    <div className={`pt-5 px-md-5 px-1 two-image-row prismic-slice ${dark_theme && "dark-theme"}`}>
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width two-image-row-container">
        <div className="sns-h2 text-theme-primary mb-3 two-image-section-title same-size-title">
          {textResolver(heading)}
        </div>
        <div className="mb-4 mb-md-5 sns-h5 head-description-row">{textResolver(description)}</div>

        <div className="pt-md-3 d-flex flex-row flex-wrap justify-content-between two-image-row">
          {doc.items.map(({ image, heading, subheading, description, link_text, link }, index) => (
            <div className="mb-5 two-image-block text-center" key={index}>
              <div className="block-image">
                <PrismicImgix
                  className="img-responsive img-responsive-height"
                  alt="user"
                  src={image.url}
                  alt={image.alt}
                  desktop="450px"
                  mobile="100%"
                  tablet="260px"
                  largeDisplay="900px"
                />
              </div>
              <div className="mt-md-4 mt-3 font-weight-bold text-theme-primary block-title">
                {textResolver(heading)}
              </div>
              <div className="mt-2 font-weight-bold text-grey-97 block-text">
                {textResolver(subheading)}
              </div>
              <div className="my-3 sns-h5 text-grey-23 block-description">
                {textResolver(description)}
              </div>
              {link?.url && (
                <PrismicLinkTag
                  urlText={link_text}
                  url={link?.url}
                  target={link?.target}
                  className="program-link font-weight-bold ls-3 block-footer-link"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TwoImageRow;
